// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen.js';
import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client/index.js';
import type { HotelActionListSharesGsheetsRateChartData, HotelActionListSharesGsheetsRateChartErrors, HotelActionListSharesGsheetsRateChartResponses, HotelActionMakeExcelRateChartData, HotelActionMakeExcelRateChartErrors, HotelActionMakeExcelRateChartResponses, HotelActionMakeGsheetsRateChartData, HotelActionMakeGsheetsRateChartErrors, HotelActionMakeGsheetsRateChartResponses, HotelActionShareGsheetsRateChartData, HotelActionShareGsheetsRateChartErrors, HotelActionShareGsheetsRateChartResponses, HotelActionUnshareGsheetsRateChartData, HotelActionUnshareGsheetsRateChartErrors, HotelActionUnshareGsheetsRateChartResponses, JobDownloadData, JobDownloadErrors, JobDownloadResponses } from './types.gen.js';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List the shares of a gsheets chart.
 */
export const hotelActionListSharesGsheetsRateChart = <ThrowOnError extends boolean = false>(options: Options<HotelActionListSharesGsheetsRateChartData, ThrowOnError>): RequestResult<HotelActionListSharesGsheetsRateChartResponses, HotelActionListSharesGsheetsRateChartErrors, ThrowOnError> => (options.client ?? client).get<HotelActionListSharesGsheetsRateChartResponses, HotelActionListSharesGsheetsRateChartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels/{hotelId}/actions/list_shares_gsheets_rate_chart',
    ...options
});

/**
 * Generate and download the latest excel chart.
 */
export const hotelActionMakeExcelRateChart = <ThrowOnError extends boolean = false>(options: Options<HotelActionMakeExcelRateChartData, ThrowOnError>): RequestResult<HotelActionMakeExcelRateChartResponses, HotelActionMakeExcelRateChartErrors, ThrowOnError> => (options.client ?? client).post<HotelActionMakeExcelRateChartResponses, HotelActionMakeExcelRateChartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels/{hotelId}/actions/make_excel_rate_chart',
    ...options
});

/**
 * Generate a gsheets chart and return a URI for it.
 */
export const hotelActionMakeGsheetsRateChart = <ThrowOnError extends boolean = false>(options: Options<HotelActionMakeGsheetsRateChartData, ThrowOnError>): RequestResult<HotelActionMakeGsheetsRateChartResponses, HotelActionMakeGsheetsRateChartErrors, ThrowOnError> => (options.client ?? client).post<HotelActionMakeGsheetsRateChartResponses, HotelActionMakeGsheetsRateChartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels/{hotelId}/actions/make_gsheets_rate_chart',
    ...options
});

/**
 * Share a gsheets chart with an email address.
 */
export const hotelActionShareGsheetsRateChart = <ThrowOnError extends boolean = false>(options: Options<HotelActionShareGsheetsRateChartData, ThrowOnError>): RequestResult<HotelActionShareGsheetsRateChartResponses, HotelActionShareGsheetsRateChartErrors, ThrowOnError> => (options.client ?? client).post<HotelActionShareGsheetsRateChartResponses, HotelActionShareGsheetsRateChartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels/{hotelId}/actions/share_gsheets_rate_chart',
    ...options
});

/**
 * Un-share a gsheets chart with an email address.
 */
export const hotelActionUnshareGsheetsRateChart = <ThrowOnError extends boolean = false>(options: Options<HotelActionUnshareGsheetsRateChartData, ThrowOnError>): RequestResult<HotelActionUnshareGsheetsRateChartResponses, HotelActionUnshareGsheetsRateChartErrors, ThrowOnError> => (options.client ?? client).post<HotelActionUnshareGsheetsRateChartResponses, HotelActionUnshareGsheetsRateChartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/hotels/{hotelId}/actions/unshare_gsheets_rate_chart',
    ...options
});

/**
 * Run a built-in query and download the results as tsv
 */
export const jobDownload = <ThrowOnError extends boolean = false>(options: Options<JobDownloadData, ThrowOnError>): RequestResult<JobDownloadResponses, JobDownloadErrors, ThrowOnError> => (options.client ?? client).post<JobDownloadResponses, JobDownloadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/reporting/download',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
